require("core-js/modules/es.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./gov.router", "@/router/person.router", "@/router/ent.router"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./gov.router"), require("@/router/person.router"), require("@/router/ent.router"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.gov, global.person, global.ent);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _gov, _person, _ent) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-gov-report/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _gov = _interopRequireDefault(_gov);
  _person = _interopRequireDefault(_person);
  _ent = _interopRequireDefault(_ent);
  var routes = [{
    path: '/',
    name: 'Index',
    component: function component() {
      return import('@/pages/index');
    }
  }, _gov.default, _person.default, _ent.default, {
    path: '*',
    name: 'NotFount',
    component: function component() {
      return import('@/pages/notFount');
    },
    meta: {
      title: '404'
    }
  }];
  var _default = routes;
  _exports.default = _default;
});